export const tokenAddresses = {
  EUL: "0xca632FA58397391C750c13F935DAA61AbBe0BaA6",
  eUSD: "0x0000000000000000000000000000000000000000",
  rEUL: "0xe2011F2bF6556863c3bacE991Efc8DaC26CD84c2",
  seUSD: "0x0000000000000000000000000000000000000000",
} as const
